import React, { useState, useEffect } from "react";
import "./style.css";
import searchIcon from "./search.svg";
import axios from "axios";
import Searchrecom from "./searchSuggest";
import { API } from "../../Api";
import { Redirect } from "react-router-dom";

function createCard(data) {
  return (
    <Searchrecom name={data.name} id={data.pr_id} categorie={data.categorie} />
  );
}

export default function Search() {
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState("");
  const [suggest, setSuggest] = useState([]);
  const [redirect, setRedirect] = useState(false);

  const handleChange = (e) => {
    const query = e.target.value
      .trim()
      .replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, "");
    console.log(value);
    setValue(query);
    if (value.length > 2) {
      setLoading(true);
      axios.get(`${API}products/search/${value}`).then((res) => {
        console.log(res.data.data);
        if (res.status === 200) {
          if (res.data.data.length === 0) {
            setSuggest([
              {
                name: "Try to search another Items..😟 ",
                pr_id: "",
                categorie: "",
              },
            ]);
          }else{
            setSuggest(res.data.data);
          }
          
        }
      });
    }
    if (value) {
      setSuggest([]);
    }
  };
  useEffect(() => {
    if (loading) {
      setSuggest([
        {
          name: "Loading...",
          pr_id: "",
          categorie: "",
        },
      ]);
    }
  }, [loading]);

  const handleEnter = (e) => {
    if (e.key === "Enter") {
      setRedirect(true);
      //   alert("You press enerererer");
    }
  };

  return (
    <div className="search-bar-div">
      {redirect && <Redirect to={`/search-query/${value}`} />}
      <div className="search-bar">
        {/**    Search bar input tag div */}
        <div className="inp">
          <input
            placeholder="Search items...."
            type="text"
            onChange={handleChange}
            onKeyDown={handleEnter}
          />
        </div>
        {/**    Search bar search icon div */}
        <div className="s-icon">
          <button>
            <img src={searchIcon} alt="icon" width="30px" />
          </button>
        </div>
      </div>
      <div className="search-dropdown">
        {suggest.length !== 0 && suggest.map(createCard)}
      </div>
    </div>
  );
}
